export {default as data} from './index.json';
import {Component} from 'intact';
import template from './index.vdt';
import './index.styl'; 

import {bind} from 'kpc';

interface Props {
    duration: number
}

export default class extends Component<Props> {
    static template = template;

    static defaults() {
        return {
            duration: 3,
        };
    }
}